define("shared/components/shared/period-time-picker", ["exports", "@ember/component", "@ember/debug", "@ember/object", "@ember/service", "@glimmer/component", "moment", "shared/types/time-picker", "@ember/template-factory"], function (_exports, _component, _debug, _object, _service, _component2, _moment, _timePicker, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _addOrSubtract;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/debug",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"moment",0,"shared/types/time-picker",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(receiver, privateSet, fn) { _assertClassBrand(privateSet, receiver); return fn; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div data-test-id="shared-period-time-picker" ...attributes>
    <Shared::BaseTimePicker
      @config={{this.rawFlatpickrConfig}}
      @disabled={{@disabled}}
      @endDate={{this.endDate}}
      @inputClass={{@inputClass}}
      @pickerClass={{concat-classes
        "o--btn o--btn--outline at--libOnboardingChecklist__timePicker"
        "qa--dhp_calendar"
        @pickerClass
      }}
      @placeholder={{@placeholder}}
      @startDate={{this.startDate}}
    >
      <:beforeInput as |pickerId|>
        <label class="u--m__0" for={{pickerId}}>
          {{svg-jar "calendar" class="o--icon u--m__r__sm"}}
          {{this.predefinedDurationText}}
        </label>
      </:beforeInput>
  
      <:calendarSiblingContent as |actions|>
        {{#if this.durations}}
          <div class="tAN--picker__range">
            {{#each this.durations as |duration|}}
              <a
                class={{concat-classes
                  "tAN--pickerRange__link"
                  (concat "qa--pgd_" duration.value duration.type)
                  duration.type
                  duration.value
                  (if (eq duration this.activeDuration) "is--selected")
                }}
                data-test-id={{concat duration.value duration.type}}
                {{on "click" (fn this.selectDuration duration)}}
                {{on "click" (fn actions.setDate this.startDate this.endDate)}}
                {{on "click" actions.close}}
              >
                {{duration.text}}
              </a>
            {{/each}}
            {{#if this.secondaryDurations}}
              <hr class="u--m__tb__xs" />
            {{/if}}
            {{#each this.secondaryDurations as |duration|}}
              <a
                class={{concat-classes
                  "tAN--pickerRange__link"
                  (concat "qa--pgd_" duration.value duration.type)
                  duration.type
                  duration.value
                  (if (eq duration this.activeDuration) "is--selected")
                }}
                data-test-id={{concat duration.value duration.type}}
                {{on "click" (fn this.selectDuration duration)}}
                {{on "click" (fn actions.setDate this.startDate this.endDate)}}
                {{on "click" actions.close}}
              >
                {{duration.text}}
              </a>
            {{/each}}
          </div>
        {{/if}}
      </:calendarSiblingContent>
    </Shared::BaseTimePicker>
  </div>
  */
  {
    "id": "4NEOJzVR",
    "block": "[[[11,0],[24,\"data-test-id\",\"shared-period-time-picker\"],[17,1],[12],[1,\"\\n  \"],[8,[39,0],null,[[\"@config\",\"@disabled\",\"@endDate\",\"@inputClass\",\"@pickerClass\",\"@placeholder\",\"@startDate\"],[[30,0,[\"rawFlatpickrConfig\"]],[30,2],[30,0,[\"endDate\"]],[30,3],[28,[37,1],[\"o--btn o--btn--outline at--libOnboardingChecklist__timePicker\",\"qa--dhp_calendar\",[30,4]],null],[30,5],[30,0,[\"startDate\"]]]],[[\"beforeInput\",\"calendarSiblingContent\"],[[[[1,\"\\n      \"],[10,\"label\"],[14,0,\"u--m__0\"],[15,\"for\",[30,6]],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"calendar\"],[[\"class\"],[\"o--icon u--m__r__sm\"]]]],[1,\"\\n        \"],[1,[30,0,[\"predefinedDurationText\"]]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[6]],[[[1,\"\\n\"],[41,[30,0,[\"durations\"]],[[[1,\"        \"],[10,0],[14,0,\"tAN--picker__range\"],[12],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[30,0,[\"durations\"]]],null]],null],null,[[[1,\"            \"],[11,3],[16,0,[28,[37,1],[\"tAN--pickerRange__link\",[28,[37,6],[\"qa--pgd_\",[30,8,[\"value\"]],[30,8,[\"type\"]]],null],[30,8,[\"type\"]],[30,8,[\"value\"]],[52,[28,[37,7],[[30,8],[30,0,[\"activeDuration\"]]],null],\"is--selected\"]],null]],[16,\"data-test-id\",[28,[37,6],[[30,8,[\"value\"]],[30,8,[\"type\"]]],null]],[4,[38,8],[\"click\",[28,[37,9],[[30,0,[\"selectDuration\"]],[30,8]],null]],null],[4,[38,8],[\"click\",[28,[37,9],[[30,7,[\"setDate\"]],[30,0,[\"startDate\"]],[30,0,[\"endDate\"]]],null]],null],[4,[38,8],[\"click\",[30,7,[\"close\"]]],null],[12],[1,\"\\n              \"],[1,[30,8,[\"text\"]]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[8]],null],[41,[30,0,[\"secondaryDurations\"]],[[[1,\"            \"],[10,\"hr\"],[14,0,\"u--m__tb__xs\"],[12],[13],[1,\"\\n\"]],[]],null],[42,[28,[37,5],[[28,[37,5],[[30,0,[\"secondaryDurations\"]]],null]],null],null,[[[1,\"            \"],[11,3],[16,0,[28,[37,1],[\"tAN--pickerRange__link\",[28,[37,6],[\"qa--pgd_\",[30,9,[\"value\"]],[30,9,[\"type\"]]],null],[30,9,[\"type\"]],[30,9,[\"value\"]],[52,[28,[37,7],[[30,9],[30,0,[\"activeDuration\"]]],null],\"is--selected\"]],null]],[16,\"data-test-id\",[28,[37,6],[[30,9,[\"value\"]],[30,9,[\"type\"]]],null]],[4,[38,8],[\"click\",[28,[37,9],[[30,0,[\"selectDuration\"]],[30,9]],null]],null],[4,[38,8],[\"click\",[28,[37,9],[[30,7,[\"setDate\"]],[30,0,[\"startDate\"]],[30,0,[\"endDate\"]]],null]],null],[4,[38,8],[\"click\",[30,7,[\"close\"]]],null],[12],[1,\"\\n              \"],[1,[30,9,[\"text\"]]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[9]],null],[1,\"        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"]],[7]]]]],[1,\"\\n\"],[13]],[\"&attrs\",\"@disabled\",\"@inputClass\",\"@pickerClass\",\"@placeholder\",\"pickerId\",\"actions\",\"duration\",\"duration\"],false,[\"shared/base-time-picker\",\"concat-classes\",\"svg-jar\",\"if\",\"each\",\"-track-array\",\"concat\",\"eq\",\"on\",\"fn\"]]",
    "moduleName": "shared/components/shared/period-time-picker.hbs",
    "isStrictMode": false
  });
  const isSameDay = (dayOne, dayTwo) => Math.abs(dayOne.diff(dayTwo, 'days')) === 0;
  let PeriodTimePickerComponent = _exports.default = (_class = (_addOrSubtract = /*#__PURE__*/new WeakSet(), class PeriodTimePickerComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _addOrSubtract);
      _initializerDefineProperty(this, "locale", _descriptor, this);
      _initializerDefineProperty(this, "userConfig", _descriptor2, this);
      _defineProperty(this, "onValueUpdate", datesArray => {
        // Note: Always assume that the date is local to userConfig.currentTimeZone
        (false && !(this.args.onDateChange) && (0, _debug.assert)('must pass an onDateChange function to use the period-time-picker', this.args.onDateChange));
        const [startDate, baseDate] = datesArray.map(string => _moment.default.tz(string, this.timezoneIdentifier));
        if (typeof this.args.onValueChange === 'function') {
          this.args.onValueChange(startDate, baseDate);
        }
        if (typeof this.args.onDateChange === 'function') {
          this.args.onDateChange(startDate, baseDate);
        }
      });
    }
    get timezoneIdentifier() {
      return this.userConfig.currentTimeZone?.identifier || '';
    }
    get durations() {
      return this.args.timePickerConfig.durations || [];
    }
    get endDate() {
      return this.args.timePickerConfig.endDate;
    }
    get secondaryDurations() {
      return this.args.timePickerConfig.secondaryDurations || [];
    }
    get startDate() {
      return this.args.timePickerConfig.startDate;
    }
    get dateOffset() {
      return this.args.dateOffset ?? 0;
    }
    get minDateAllowed() {
      return this.args.minDateAllowed;
    }
    get maxDateAllowed() {
      return this.args.maxDateAllowed;
    }
    get flatpickrDefaults() {
      return {
        altInput: true,
        allowInput: true,
        clickOpens: false,
        wrap: true,
        showMonths: 2,
        mode: 'range',
        maxDate: this.maxDateAllowed,
        minDate: this.minDateAllowed,
        defaultDate: this.locale.formatToDefaultDateRange(this.startDate, this.endDate)
      };
    }
    get rawFlatpickrConfig() {
      const {
        dateFormat = 'F j, Y',
        onDateChange,
        ...rest
      } = this.args;
      return {
        ...this.flatpickrDefaults,
        dateFormat,
        onDateChange,
        onValueUpdate: this.onValueUpdate,
        ...rest
      };
    }
    get activeDuration() {
      const durations = this.durations.filter(dateRange => {
        const baseDate = _classPrivateMethodGet(this, _addOrSubtract, _addOrSubtract2).call(this, dateRange.direction, dateRange.baseDate.clone(), this.dateOffset, 'days');
        const startDate = _classPrivateMethodGet(this, _addOrSubtract, _addOrSubtract2).call(this, dateRange.direction, baseDate.clone(), dateRange.value, dateRange.type);
        return isSameDay(startDate, this.startDate) && isSameDay(baseDate, this.endDate);
      });
      return durations.firstObject;
    }
    get predefinedDurationText() {
      if (this.activeDuration && this.durations.includes(this.activeDuration)) {
        return `${this.activeDuration.text}:`;
      }
      return undefined;
    }
    selectDuration(duration) {
      (false && !(this.args.onDateChange) && (0, _debug.assert)('must pass an onDateChange function to use the period-time-picker', this.args.onDateChange));
      const {
        baseDate,
        direction
      } = duration;
      const isBackwards = direction === _timePicker.TimePeriodDirection.Backward;
      const firstDate = _classPrivateMethodGet(this, _addOrSubtract, _addOrSubtract2).call(this, direction, baseDate.clone(), this.dateOffset, 'days').endOf('day');
      const firstDateWithTime = isBackwards ? firstDate.endOf('day') : firstDate.startOf('day');
      const secondDate = _classPrivateMethodGet(this, _addOrSubtract, _addOrSubtract2).call(this, direction, firstDate.clone(), duration.value, duration.type).startOf('day');
      const secondDateWithTime = isBackwards ? secondDate.startOf('day') : secondDate.endOf('day');
      const start = duration.direction === _timePicker.TimePeriodDirection.Backward ? secondDateWithTime : firstDateWithTime;
      const end = duration.direction === _timePicker.TimePeriodDirection.Backward ? firstDateWithTime : secondDateWithTime;
      this.args.onDateChange(_moment.default.tz(start, this.timezoneIdentifier), _moment.default.tz(end, this.timezoneIdentifier));
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "locale", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "userConfig", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "selectDuration", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "selectDuration"), _class.prototype)), _class);
  function _addOrSubtract2(direction, value) {
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }
    return direction === _timePicker.TimePeriodDirection.Backward ? value.subtract(...args) : value.add(...args);
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PeriodTimePickerComponent);
});